import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {MaryShelleyCutouts} from "../layout/MaryShelleyCutouts";
import {
    MaryShelleyStoryLayout_scene1Start,
    MaryShelleyStoryLayout_scene2Encounter,
    MaryShelleyStoryLayout_scene3Reaction,
    MaryShelleyStoryLayout_scene4Trait,
    MaryShelleyStoryLayout_scene5Trait,
    MaryShelleyStoryLayout_scene6End,
} from "../layout/MaryShelleyStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {StoryModel} from "./StoryModel";
import {StoryPromptVOProvider} from "./StoryPromptVOProvider";

export const StoryMaryShelley: StoryModel<MaryShelleySceneId, MaryShelleySlotId> = {
    storyId: BookId.Shelley,
    storyIndex: 2,
    promptVO: "she_yadina_st_{index}",
    optionVO: "she_yadina_st_{index}",
    introVO: ["she_xavier_in_001", "she_brad_in_001", "she_yadina_in_001"],
    outroVO: ["she_xavier_out_001", "she_yadina_out_001_clip", 0.5, "she_brad_out_001"],
    outroImage: "she-story-image",
    cutouts: new CutoutData(MaryShelleyCutouts),
    scenes: [
        {
            sceneId: "start",
            cc: "Xavier was walking in the woods, when suddenly something happened that was very {option-start!}",
            voIndex: 1,
            options: [
                {optionId: "spooky", cc: "Spooky", icon: "she-x-spooky-buttonimg", sfx: "sc_030_XR102A_019_Spooky Orchestra", voIndex: 2},
                {optionId: "funny", cc: "Funny", icon: "she-x-funny-buttonimg", sfx: "sc_056_XR113B_099_Flat Bass-y Horns", voIndex: 3},
                {optionId: "surprising", cc: "Surprising", icon: "she-x-surprised-buttonimg", sfx: "sc_074_surprising", voIndex: 4},
            ],
            layout: MaryShelleyStoryLayout_scene1Start,
        },
        {
            sceneId: "encounter",
            cc: "He came face to face with a {option-encounter!}",
            voIndex: 5,
            options: [
                {optionId: "ghost", cc: "Ghost", icon: "she-ghost-buttonimg", sfx: "sc_039_102A_072_Upward Chimes", voIndex: 6},
                {optionId: "monster", cc: "Book Monster", icon: "she-bookmonster-buttonimg", sfx: "sc_041_XR102A_080_Big Bass and Bell", voIndex: 7},
                {optionId: "ant", cc: "Silly Ant", icon: "she-ant-buttonimg", sfx: "sc_007_XR103A_009_Chords_to the secret museum", optionVO: "she_yadina_st_008_alt"},
                {optionId: "superhero", cc: "Super Villain", icon: "she-superhero-buttonimg", sfx: "sc_025_XR111B_014_Triumphant Intro", voIndex: 9},
            ],
            layout: MaryShelleyStoryLayout_scene2Encounter,
        },
        {
            sceneId: "reaction",
            cc: "At first, Xavier tried to {option-reaction.}",
            voIndex: 10,
            options: [
                {optionId: "run", cc: "Run Away", icon: "she-x-run-buttonimg", sfx: "sc_034_102A_004_Orchestra Hit", voIndex: 11, voDelay: 0.25},
                {optionId: "hide", cc: "Hide", icon: "she-x-hide-buttonimg", iconPosition: "center", sfx: "sc_037_XR103A_074_Rustling sounds", voIndex: 12, voDelay: 0.25},
                {optionId: "invisible", cc: "Be Invisible", icon: "she-x-invisible-buttonimg", sfx: "sc_039_102A_072_Upward Chimes", voIndex: 13, voDelay: 0.25},
                {optionId: "statue", cc: "Be a Statue", icon: "she-x-statue-buttonimg", sfx: "sc_049_XR111B_002_Heavy Book Impact", voIndex: 14, voDelay: 0.25},
            ],
            layout: MaryShelleyStoryLayout_scene3Reaction,
        },
        {
            sceneId: "trait",
            cc: "But then, Xavier decided to be {option-trait.}",
            voIndex: 15,
            options: [
                {optionId: "traitBrave", cc: "Brave", nextSceneId: "brave", icon: "she-x-brave-buttonimg", sfx: "sc_011_XR102A_018_Triumphant Music Xavier", voIndex: 16, voDelay: 0.5},
                {optionId: "traitKind", cc: "Kind", nextSceneId: "kind", icon: "she-x-kind-buttonimg", sfx: "sc_002_XR103A_003_ Rising String Notes", voIndex: 17, voDelay: 0.5},
                {optionId: "traitFunny", cc: "Funny", nextSceneId: "funny", icon: "she-x-funny_2-button-img", sfx: "sc_056_XR113B_099_Flat Bass-y Horns", voIndex: 18, voDelay: 0.5},
            ],
            layout: MaryShelleyStoryLayout_scene4Trait,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_007"),
            },
        },
        {
            sceneId: "brave",
            sceneIndex: 5,
            sceneSubIndex: "_1",
            cc: "Xavier stood bravely, holding {option-item!}",
            voIndex: 19,
            options: [
                {slotId: "item", optionId: "lantern", cc: "a Lantern", nextSceneId: "end", icon: "she-lantern-buttonimg", iconPosition: "center", sfx: "sc_051_XR102A_003_Flashlight Switch", voIndex: 20},
                {slotId: "item", optionId: "broccoli", cc: "a Piece of Broccoli", nextSceneId: "end", icon: "she-broccoli-buttonimg", iconPosition: "center", sfx: "sc_056_XR113B_099_Flat Bass-y Horns", voIndex: 21},
                {slotId: "item", optionId: "flashlight", cc: "a Flashlight", nextSceneId: "end", icon: "she-flashlight-buttonimg", iconPosition: "center", sfx: "sc_051_XR102A_003_Flashlight Switch", voIndex: 22},
                {slotId: "item", optionId: "wand", cc: "a Wand", nextSceneId: "end", icon: "she-wand-buttonimg", iconPosition: "center", sfx: "sc_073_quicktada", voIndex: 23},
            ],
            layout: MaryShelleyStoryLayout_scene5Trait,
        },
        {
            sceneId: "kind",
            sceneIndex: 5,
            sceneSubIndex: "_2",
            sfx: "sc_002_XR103A_003_ Rising String Notes",
            cc: "So, Xavier kindly offered to share his {option-item.}",
            voIndex: 24,
            options: [
                {slotId: "item", optionId: "sandwich", cc: "Cheese and Jelly Sandwich", nextSceneId: "end", icon: "she-sandwich-buttonimg", iconPosition: "center", voIndex: 25},
                {slotId: "item", optionId: "toy", cc: "Toy Train", nextSceneId: "end", icon: "she-toy-buttonimg", iconPosition: "center", voIndex: 26},
                {slotId: "item", optionId: "crayons", cc: "Crayons", nextSceneId: "end", icon: "she-crayons-buttonimg", iconPosition: "center", voIndex: 27},
                {slotId: "item", optionId: "bear", cc: "Teddy Bear", nextSceneId: "end", icon: "she-teddybear-buttonimg", iconPosition: "center", voIndex: 28},
            ],
            layout: MaryShelleyStoryLayout_scene5Trait,
        },
        {
            sceneId: "funny",
            sceneIndex: 5,
            sceneSubIndex: "_3",
            sfx: "sc_073_quicktada",
            cc: "Xavier turned around and put on a silly {option-item.}",
            voIndex: 29,
            options: [
                {slotId: "item", optionId: "tophat", cc: "Hat", nextSceneId: "end", icon: "she-tophat-buttonimg", iconPosition: "center", sfx: "", voIndex: 30},
                {slotId: "item", optionId: "glasses", cc: "Pair of Glasses", nextSceneId: "end", icon: "she-sillyglasses-buttonimg", iconPosition: "center", sfx: "", voIndex: 31},
                {slotId: "item", optionId: "bowtie", cc: "Bow Tie", nextSceneId: "end", icon: "she-bowtie-buttonimg", iconPosition: "center", sfx: "", voIndex: 32},
                {slotId: "item", optionId: "moustache", cc: "Moustache", nextSceneId: "end", icon: "she-moustache-buttonimg", iconPosition: "center", sfx: "", voIndex: 33},
            ],
            layout: MaryShelleyStoryLayout_scene5Trait,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Xavier, "re_xavier_009"),
            },
        },
        {
            sceneId: "end",
            sceneIndex: 6,
            vo: new StoryPromptVOProvider(
                {option: "ghost", vo: "she_yadina_st_042", cc: "To Xavier's surprise, the Ghost said,<br>{option-end}"},
                {option: "monster", vo: "she_yadina_st_034", cc: "To Xavier's surprise, the Book Monster said,<br>{option-end}"},
                {option: "ant", vo: "she_yadina_st_035", cc: "To Xavier's surprise, the Silly Ant said,<br>{option-end}"},
                {option: "superhero", vo: "she_yadina_st_036", cc: "To Xavier's surprise, the Super Villain said,<br>{option-end}"},
            ),
            options: [
                {optionId: "boogie", cc: "\"Let's boogie!\"", icon: "she-boogie-buttonimg", iconPosition: "top", sfx: "sc_001_XR103A_ Music Show Open No Singing", voIndex: 37},
                {optionId: "tickle", cc: "\"Let's giggle!\"", icon: "she-feather-buttonimg", iconPosition: "center", sfx: "sc_009_XR101B_006_Fluttery Flute", voIndex: 38},
                {
                    optionId: "pie", cc: "\"Let's eat pie!\"", icon: "she-pie-buttonimg", iconPosition: "center", voIndex: 39,
                    sfx: {"sc_039_102A_072_Upward Chimes": 0, "sc_019_XR111B_131_Whoosh": 0, "sc_049_XR111B_002_Heavy Book Impact": 0.4},
                },
                {optionId: "friends", cc: "\"Let's be friends!\"", icon: "she-bestfriends-buttonimg", iconPosition: "center", sfx: "sc_075_bestfriends", voIndex: 40},
            ],
            layout: MaryShelleyStoryLayout_scene6End,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_006_alt", true),
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "she_yadina_st_041"),
                ),
            },
        },
    ],
};

export type MaryShelleySceneId =
    "start"
    | "encounter"
    | "reaction"
    | "trait"
    | "brave"
    | "kind"
    | "funny"
    | "end";
export type MaryShelleySlotId =
    "start"
    | "encounter"
    | "reaction"
    | "trait"
    | "item"
    | "end";
